import * as React from 'react';
type SvgGoogleDarkProps = React.SVGProps<SVGSVGElement>;
const SvgGoogleDark = (props: SvgGoogleDarkProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="33"
    fill="none"
    viewBox="0 0 32 33"
  >
    <path
      fill="#1A1A1A"
      d="m24.783 21.526-4.077-3.735L5.74 31.542zM24.783 11.362 5.74 1.346l14.966 13.751zM30.753 18.335c1.22-.888 1.22-2.89-.081-3.778l-3.995-2.117-4.457 4.008 4.457 4.008zM1.83 32.348 19.234 16.44 1.83.538C.95.96.36 1.73.36 2.73v27.423c0 1 .59 1.77 1.47 2.194"
    ></path>
  </svg>
);

export default SvgGoogleDark;
